import { HTMLAttributes } from 'react';
import { selectIsMissionControlHomepageFeatureFlagOn } from 'core/userContext/selectors';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Logo, LogoVariants } from 'ui/logo';

export const NAVBAR_LOGO = {
  testId: 'nav-logo',
  campaignIndexUrl: '/campaigns/manage',
  homeUrl: '/',
};

const { testId, campaignIndexUrl, homeUrl } = NAVBAR_LOGO;

const StyledLink = styled(Link)`
  position: relative;
  display: flex;
  align-self: center;
`;

type NavLogoProps = HTMLAttributes<HTMLAnchorElement> & {
  height?: number;
  id?: string;
  variant?: LogoVariants;
};

export const NavLogo = ({ height = 36, variant, ...props }: NavLogoProps) => {
  const isMissionControlHomepageFeatureFlagOn = useSelector(
    selectIsMissionControlHomepageFeatureFlagOn,
  );

  return (
    <StyledLink
      to={isMissionControlHomepageFeatureFlagOn ? homeUrl : campaignIndexUrl}
      data-test={testId}
      {...props}
      data-variant={`${variant}-link`}
    >
      <Logo height={height} variant={variant} />
    </StyledLink>
  );
};
